module.exports = __webpack_public_path__ + "img/btn_jieshu@2x.2d24273d.png";